import { render } from "./MMUpdateNews.vue?vue&type=template&id=621762d3"
import script from "./MMUpdateNews.vue?vue&type=script&lang=js"
export * from "./MMUpdateNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__